import React from "react"
import * as AppConstants from "../../../../utility/AppConstants"
import 'Css/table.css'

function TabRicaviCompensi(props: any) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_RICAVI_DICHIARATI}{" "}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.ricaviCompensiDichiaratiTot
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.ricaviCompensiDichiaratiTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.ricaviCompensiDichiaratiTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.ricaviCompensiDichiaratiTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.ricaviCompensiDichiaratiTot
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_RICAVI_STIMATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.ricaviCompensiStimatiTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.ricaviCompensiStimatiTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.ricaviCompensiStimatiTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo4.ricaviCompensiStimatiTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.ricaviCompensiStimatiTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>

            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_RICAVI_ADDETTO_DICHIARATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.ricaviCompensiAddDichiarati
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.ricaviCompensiAddDichiarati
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.ricaviCompensiAddDichiarati
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.ricaviCompensiAddDichiarati
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.ricaviCompensiAddDichiarati
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_RICAVI_ADDETTO_STIMATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.ricaviCompensiAddStimati
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.ricaviCompensiAddStimati
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.ricaviCompensiAddStimati
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.ricaviCompensiAddStimati
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.ricaviCompensiAddStimati
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
        </React.Fragment>
    )
}
export default TabRicaviCompensi
